import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { removeTaskError } from "@planzone/dto";

const initialState: State = [];

function handleRequest(
  state: State,
  task: Boundaries["removeTask"]["request"],
): State {
  return [
    ...state,
    { task, request: setRequestStateToPending(), error: removeTaskError },
  ];
}

function handleSuccess(
  state: State,
  task: Boundaries["removeTask"]["success"],
): State {
  return state.map((item) =>
    item.task.uuid === task.uuid
      ? { task, request: setRequestStateToSuccess(), error: removeTaskError }
      : item,
  );
}

function handleFailure(
  state: State,
  { task, error }: Boundaries["removeTask"]["failure"],
): State {
  return state.map((item) =>
    item.task.uuid === task.uuid
      ? { task, request: setRequestStateToFailure(), error }
      : item,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeTaskRequested]: handleRequest,
    [events.removeTaskSucceeded]: handleSuccess,
    [events.removeTaskFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
